import React from 'react';
import '../../../../dmView/style/App.css';
import '../PlayerUI.css';
import Icon from '../../../components/Icon';

const defaultPlayerOptions = {
    showBlood: true,
    showDead: true,
    showHp: true,
    showHpBar: false,
    showAc: true
};

const otherPlayerOption = {
    showBlood: true,
    showDead: true,
    showHp: true,
    showHpBar: false,
    showAc: false
};

const CharacterController = ({ creature, otherPlayers, isTurn, handleBackButton, socket }) => {
    let opSize = .5;

    return (
        <div className="selectedCharacterScreenContainer">
            <button
                type="button"
                style={{ position: 'absolute', top: 5, left: 5, background: 'transparent', border: 'none', color: 'inherit', cursor: 'pointer' }}
                onClick={handleBackButton}
                aria-label="Go back"
            >
                {'<<<'}
            </button>
            <div className="playerUiOtherPlayersContainer">
                {otherPlayers.map(op => {
                    if(creature.creatureGuid !== op.creatureGuid)
                        return (
                            <Icon
                                key={op.creatureGuid}
                                isTurn={false}
                                creature={op}
                                iconOptions={otherPlayerOption}
                                iconSize={{ width: 200*opSize, height: 240*opSize }}
                                smallIcon
                                socket={socket}
                            />
                        )
                })}
            </div>
            <div className='selectedCharacterContainer'>
                <Icon
                    key={creature.creatureGuid}
                    isTurn={false}
                    creature={creature}
                    iconOptions={defaultPlayerOptions}
                    iconSize={{ width: 200, height: 240 }}
                    clickable
                    socket={socket}
                />
            </div>
            
        </div>
    )
};

export default CharacterController;